// GERADO POR `pnpm gen:api` — NÃO EDITAR À MÃO.
// Fonte: specs/AIM-POC/contracts/api-backend.md › "Erros — taxonomia de `code`"
// source-sha256: c09bb8d1946f8a5b203add98d66007d31f4cd355f30fd21b0de3575d584daae4

/** Taxonomia completa de `code` do envelope de erro (produto + middleware + transporte). */
export const ERROR_CODES = [
  'admission_certificate_mismatch',
  'admission_not_registered',
  'admission_refused',
  'admission_token_expired',
  'admission_token_invalid',
  'admission_unreachable',
  'agent_relink_only_internal',
  'agent_resource_not_removable',
  'agent_route_not_served_by_identity',
  'agent_run_error',
  'agent_stream_incomplete',
  'apim_id_duplicado',
  'apim_ilegivel',
  'apim_nao_configurado',
  'apim_nao_pronto',
  'app_desconhecida_na_politica',
  'app_inexistente',
  'aprovacao_nao_pendente',
  'atribuicao_incompleta',
  'basename_duplicado',
  'borda_recusou',
  'campo_desconhecido',
  'catalogo_indisponivel',
  'chat_entry_namespace_not_allowed',
  'chat_entry_not_served_by_identity',
  'chat_entry_secret_unreadable',
  'chat_entry_service_mixed',
  'chat_entry_service_not_found',
  'claims_invalidas',
  'cluster_inalcancavel',
  'cluster_nao_configurado',
  'configmap_falhou',
  'conta_nao_autorizada',
  'container_inexistente',
  'contrato_inexistente',
  'credenciais_invalidas',
  'dados_invalidos',
  'deployment_inexistente',
  'detalhe_indisponivel',
  'digest_inexistente',
  'digest_invalido',
  'discovery_em_execucao',
  'email_duplicado',
  'environment_in_use',
  'environment_is_default',
  'erro_interno',
  'estado_parcial',
  'google_estado_invalido',
  'google_falhou',
  'google_nao_configurado',
  'http_500',
  'identidade_congelada',
  'imagem_fora_do_registry',
  'indisponivel',
  'label_ausente',
  'limite_nao_aceito',
  'llm_disabled',
  'login_bloqueado',
  'materializacao_recusada',
  'middleware_fora',
  'middleware_nao_configurado',
  'middleware_sem_resposta',
  'model_unreachable',
  'modulo_inexistente',
  'nao_autenticado',
  'nao_encontrado',
  'nao_implementado',
  'nome_duplicado',
  'origem_nao_permitida',
  'papel_duplicado',
  'papel_em_uso',
  'patch_falhou',
  'pdp_inalcancavel',
  'pdp_nao_configurado',
  'pdp_recusou',
  'pessoa_desconhecida',
  'postura_sem_vinculo_de_artefato',
  'recurso_inexistente',
  'registry_ilegivel',
  'rego_indisponivel',
  'rego_nao_validado',
  'requisicao_invalida',
  'rota_ausente',
  'rota_desativada',
  'sem_contrato_ativo',
  'sem_permissao',
  'serviceaccount_falhou',
  'sessao_expirada',
  'site_em_uso',
  'site_padrao',
  'slug_duplicado',
  'slug_nao_permitido',
  'slug_rename_only_in_drawer',
  'tool_em_uso',
  'tool_in_another_site',
  'tool_nao_catalogada',
  'tool_server_ambiguous',
  'ultimo_admin',
  'valor_invalido',
  'versao_antiga',
  'versao_antiga_executor',
  'write_guard',
] as const;

export type ErrorCode = (typeof ERROR_CODES)[number];

export function isErrorCode(value: string): value is ErrorCode {
  return (ERROR_CODES as readonly string[]).includes(value);
}
